import React, { useState } from "react";

import Input from "@material-ui/core/Input";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import EditIcon from "@material-ui/icons/Edit";
import CloseIcon from "@material-ui/icons/Close";
import CheckIcon from "@material-ui/icons/Check";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import CircularProgress from "@material-ui/core/CircularProgress";
import { StyledGrid } from "components/simple";

import { color } from "style/constants";

interface Props {
  canEdit?: boolean;
  currentValue: string;
  onSubmit: (value: string) => Promise<any>;
  onDelete?: () => Promise<any>;
  type: "number" | "text";
  min?: number;
  max?: number;
}

const InputEdit: React.FC<Props> = ({
  canEdit = true,
  currentValue,
  type,
  onSubmit,
  onDelete,
  min,
  max
}: Props) => {
  const [loading, setLoading] = useState(false);
  const [edit, setEdit] = useState(false);
  const [value, setValue] = useState("");

  const width = type === "number" ? "4rem" : "auto";
  const textAlign = type === "number" ? "center" : "left";

  return (
    <>
      {edit ? (
        <StyledGrid container wrap="nowrap">
          <Input
            type={type}
            autoFocus
            placeholder={currentValue || ""}
            value={value}
            onChange={event => setValue(event.target.value)}
            inputProps={{
              style: { textAlign, width },
              min,
              max
            }}
          />
          {loading ? (
            <CircularProgress disableShrink color="secondary" size={20} thickness={5} />
          ) : (
            <StyledGrid item>
              <Tooltip title="Save">
                <span>
                  <IconButton
                    disabled={!value}
                    onClick={async () => {
                      if (value) {
                        setLoading(true);
                        await onSubmit(value);
                        setValue("");
                        setLoading(false);
                        setEdit(false);
                      }
                    }}
                  >
                    <CheckIcon
                      style={{
                        color: value ? color.DARKGREEN : color.PALEGRAY
                      }}
                    />
                  </IconButton>
                </span>
              </Tooltip>
              <Tooltip title="Cancel">
                <IconButton
                  onClick={() => {
                    setValue("");
                    setEdit(false);
                  }}
                >
                  <CloseIcon color="error" />
                </IconButton>
              </Tooltip>
              {typeof onDelete !== "undefined" && currentValue && (
                <Tooltip title="Delete">
                  <IconButton
                    onClick={async () => {
                      setLoading(true);

                      await onDelete();
                      setValue("");
                      setLoading(false);
                      setEdit(false);
                    }}
                  >
                    <DeleteOutlineIcon color="error" />
                  </IconButton>
                </Tooltip>
              )}
            </StyledGrid>
          )}
        </StyledGrid>
      ) : (
        <>
          <span>{currentValue || ""}</span>
          {canEdit && (
            <Tooltip title="Edit">
              <IconButton onClick={() => setEdit(true)}>
                <EditIcon />
              </IconButton>
            </Tooltip>
          )}
        </>
      )}
    </>
  );
};

export default InputEdit;
